import React, { useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";

export default function WithdrawMessage({ message, onWithdrawn }) {
  const { lang } = useI18n();
  const it = lang === "it";
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  if (!message.is_mine || message.content_removed) return null;
  const withdraw = async () => {
    if (busy) return;
    setBusy(true); setError(false);
    try {
      await api.post(`/messages/${message.id}/withdraw`);
      onWithdrawn(message.id);
      setConfirm(false);
    } catch { setError(true); }
    finally { setBusy(false); }
  };
  return <div className="text-xs mt-2">
    {!confirm ? <button type="button" onClick={() => setConfirm(true)}>{it ? "Ritira contenuto" : "Withdraw content"}</button> : <>
      <p>{it ? "Il contenuto non sarà più accessibile nella chat. La cancellazione definitiva richiede la verifica di eventuali obblighi di conservazione. Le copie già salvate dal destinatario non possono essere ritirate." : "The content will no longer be accessible in the chat. Final erasure requires checking any retention obligations. Copies already saved by the recipient cannot be withdrawn."}</p>
      <button type="button" disabled={busy} onClick={withdraw}>{it ? "Conferma ritiro" : "Confirm withdrawal"}</button>{" · "}
      <button type="button" disabled={busy} onClick={() => setConfirm(false)}>{it ? "Annulla" : "Cancel"}</button>
    </>}
    {error && <p role="alert">{it ? "Ritiro non confermato. Ricarica la chat e riprova." : "Withdrawal not confirmed. Reload the chat and retry."}</p>}
  </div>;
}
